import React, { useMemo, useState } from "react";
import { getYouTubeThumb } from "../../../utils/utils";
import PopupModal from "../popupModal/PopupModal";
import classes from "./VideoPreview.module.scss";

const VideoPreview = ({ url, alt = "", className = "", showPlayIcon = true, duration, thumbSrc, }) => {

    const [open, setOpen] = useState(false);
    const previewSrc = useMemo(() => {
        if (!url)
            return "";
        if (thumbSrc)
            return thumbSrc;
        if (url.includes("youtube.com") || url.includes("youtu.be"))
            return getYouTubeThumb(url);
        return "";
    }, [url, thumbSrc]);

    return (
        <>
            <button type="button" className={`${classes.videoFrame} ${className}`} onClick={() => setOpen(true)} aria-label={alt || "Play video"}  >
                {previewSrc ?
                    <img className={classes.previewImage} src={previewSrc} alt={alt} />
                    :
                    <div className={classes.fallback}>Play</div>
                }
                {showPlayIcon && <span className={classes.playIcon}>▶</span>}
                {duration && <span className={classes.duration}>{duration}</span>}
            </button>
            {open && <PopupModal url={url} onClose={() => setOpen(false)} />}
        </>
    );
};

export default VideoPreview;
